import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { ProblemSection } from '../components/ProblemSection';
import { BlueprintSection } from '../components/BlueprintSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { SprintPlanSection } from '../components/SprintPlanSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-dark-950 text-gray-300 font-sans selection:bg-cyan-500/30 selection:text-cyan-200" data-id="element-199">
      <main data-id="element-200">
        <HeroSection data-id="element-201" />
        <StorySection data-id="element-202" />
        <ProblemSection data-id="element-203" />
        <BlueprintSection data-id="element-204" />
        <CaseStudySection data-id="element-205" />
        <SprintPlanSection data-id="element-206" />
        <CTASection data-id="element-207" />
        <Footer data-id="element-208" />
      </main>
    </div>;
}